export const RAFFLE_MY_TICKETS_TABS = 'RAFFLE_MY_TICKETS_TABS';

export const RAFFLE_AVAILABLE_TABS_REQUEST = 'RAFFLE_AVAILABLE_TABS_REQUEST';
export const RAFFLE_AVAILABLE_TABS_SUCCESS = 'RAFFLE_AVAILABLE_TABS_SUCCESS';
export const RAFFLE_AVAILABLE_TABS_FAILURE = 'RAFFLE_AVAILABLE_TABS_FAILURE';

export const RAFFLE_PAGE_DATA_REQUEST = 'RAFFLE_PAGE_DATA_REQUEST';
export const RAFFLE_PAGE_DATA_SUCCESS = 'RAFFLE_PAGE_DATA_SUCCESS';
export const RAFFLE_PAGE_DATA_FAILURE = 'RAFFLE_PAGE_DATA_FAILURE';

export const RAFFLE_PRIZE_DATA_REQUEST = 'RAFFLE_PRIZE_DATA_REQUEST';
export const RAFFLE_PRIZE_DATA_SUCCESS = 'RAFFLE_PRIZE_DATA_SUCCESS';
export const RAFFLE_PRIZE_DATA_FAILURE = 'RAFFLE_PRIZE_DATA_FAILURE';

export const GET_RAFFLE_MY_TICKET_LIST_REQUEST = 'GET_RAFFLE_MY_TICKET_LIST_REQUEST';
export const GET_RAFFLE_MY_TICKET_LIST_SUCCESS = 'GET_RAFFLE_MY_TICKET_LIST_SUCCESS';
export const GET_RAFFLE_MY_TICKET_LIST_FAILURE = 'GET_RAFFLE_MY_TICKET_LIST_FAILURE';
export const GET_RAFFLE_MY_TICKET_LIST_RESET = 'GET_RAFFLE_MY_TICKET_LIST_RESET';

export const GET_RAFFLE_MY_TICKET_DETAIL_REQUEST = 'GET_RAFFLE_MY_TICKET_DETAIL_REQUEST';
export const GET_RAFFLE_MY_TICKET_DETAIL_SUCCESS = 'GET_RAFFLE_MY_TICKET_DETAIL_SUCCESS';
export const GET_RAFFLE_MY_TICKET_DETAIL_FAILURE = 'GET_RAFFLE_MY_TICKET_DETAIL_FAILURE';
export const GET_RAFFLE_MY_TICKET_DETAIL_RESET = 'GET_RAFFLE_MY_TICKET_DETAIL_RESET';

export const RAFFLE_SERIAL_DATA_REQUEST = 'RAFFLE_SERIAL_DATA_REQUEST';
export const RAFFLE_SERIAL_DATA_SUCCESS = 'RAFFLE_SERIAL_DATA_SUCCESS';
export const RAFFLE_SERIAL_DATA_FAILURE = 'RAFFLE_SERIAL_DATA_FAILURE';

export const RAFFLE_SPECIAL_DATA_REQUEST = 'RAFFLE_SPECIAL_DATA_REQUEST';
export const RAFFLE_SPECIAL_DATA_SUCCESS = 'RAFFLE_SPECIAL_DATA_SUCCESS';
export const RAFFLE_SPECIAL_DATA_FAILURE = 'RAFFLE_SPECIAL_DATA_FAILURE';
export const RAFFLE_SPECIAL_DATA_RESET = 'RAFFLE_SPECIAL_DATA_RESET';

export const GET_RAFFLE_DRAWS_REQUEST = 'GET_RAFFLE_DRAWS_REQUEST';
export const GET_RAFFLE_DRAWS_SUCCESS = 'GET_RAFFLE_DRAWS_SUCCESS';
export const GET_RAFFLE_DRAWS_FAILURE = 'GET_RAFFLE_DRAWS_FAILURE';

export const GET_RAFFLE_DRAW_ACTIVE_REQUEST = 'GET_RAFFLE_DRAW_ACTIVE_REQUEST';
export const GET_RAFFLE_DRAW_ACTIVE_SUCCESS = 'GET_RAFFLE_DRAW_ACTIVE_SUCCESS';
export const GET_RAFFLE_DRAW_ACTIVE_FAILURE = 'GET_RAFFLE_DRAW_ACTIVE_FAILURE';

export const RAFFLE_ONE_OF_SERIAL_REQUEST = 'RAFFLE_ONE_OF_SERIAL_REQUEST';
export const RAFFLE_ONE_OF_SERIAL_SUCCESS = 'RAFFLE_ONE_OF_SERIAL_SUCCESS';
export const RAFFLE_ONE_OF_SERIAL_FAILURE = 'RAFFLE_ONE_OF_SERIAL_FAILURE';

export const GET_RAFFLE_QUERY_RESULT_REQUEST = 'GET_RAFFLE_QUERY_RESULT_REQUEST';
export const GET_RAFFLE_QUERY_RESULT_SUCCESS = 'GET_RAFFLE_QUERY_RESULT_SUCCESS';
export const GET_RAFFLE_QUERY_RESULT_FAILURE = 'GET_RAFFLE_QUERY_RESULT_FAILURE';
export const GET_RAFFLE_QUERY_RESULT_RESET = 'GET_RAFFLE_QUERY_RESULT_RESET';

export const TOGGLE_TICKET_TO_RAFFLE_SLIP = 'TOGGLE_TICKET_TO_RAFFLE_SLIP';
export const CLEAR_RAFFLE_SLIP = 'CLEAR_RAFFLE_SLIP';
export const SET_RAFFLESLIP_FROM_LOCAL_STORAGE = 'SET_RAFFLESLIP_FROM_LOCAL_STORAGE';

export const SET_RAFFLE_RENDERER = 'SET_RAFFLE_RENDERER';

export const RAFFLE_BUY_TICKETS_REQUEST = 'RAFFLE_BUY_TICKETS_REQUEST';
export const RAFFLE_BUY_TICKETS_SUCCESS = 'RAFFLE_BUY_TICKETS_SUCCESS';
export const RAFFLE_BUY_TICKETS_FAILURE = 'RAFFLE_BUY_TICKETS_FAILURE';
export const RAFFLE_BUY_TICKETS_RESET = 'RAFFLE_BUY_TICKETS_RESET';

export const RAFFLE_SHARED_TICKET_LIST_REQUEST = 'RAFFLE_SHARED_TICKET_LIST_REQUEST';
export const RAFFLE_SHARED_TICKET_LIST_SUCCESS = 'RAFFLE_SHARED_TICKET_LIST_SUCCESS';
export const RAFFLE_SHARED_TICKET_LIST_FAILURE = 'RAFFLE_SHARED_TICKET_LIST_FAILURE';

export const RAFFLE_SHARED_TICKET_LIST_RESET = 'RAFFLE_SHARED_TICKET_LIST_RESET';

export const RAFFLE_SHARED_TICKET_DETAIL_REQUEST = 'RAFFLE_SHARED_TICKET_DETAIL_REQUEST';
export const RAFFLE_SHARED_TICKET_DETAIL_SUCCESS = 'RAFFLE_SHARED_TICKET_DETAIL_SUCCESS';
export const RAFFLE_SHARED_TICKET_DETAIL_FAILURE = 'RAFFLE_SHARED_TICKET_DETAIL_FAILURE';
export const RAFFLE_SHARED_TICKET_DETAIL_RESET = 'RAFFLE_SHARED_TICKET_DETAIL_RESET';

export const RAFFLE_SHARED_TICKET_BUY_REQUEST = 'RAFFLE_SHARED_TICKET_BUY_REQUEST';
export const RAFFLE_SHARED_TICKET_BUY_SUCCESS = 'RAFFLE_SHARED_TICKET_BUY_SUCCESS';
export const RAFFLE_SHARED_TICKET_BUY_FAILURE = 'RAFFLE_SHARED_TICKET_BUY_FAILURE';

